import ComingSimple from '../Components/Pages/ComingSoon/ComingSimple';
import { appPath, APP_PATHS } from '../utils/appPaths.js';
import CreatePwd from '../Components/Pages/Auth/CreatePwd';
import ForgetPwd from '../Auth/RecoverPwd/ForgotPassword';
import ResetPwd from '../Auth/RecoverPwd/ResetPassword';
// import OtpVerif from '../Auth/RecoverPwd/OtpVerif';
// import ForgetPwd2 from '../Components/Pages/Auth/ForgetPwd';
import LoginOne from '../Components/Pages/Auth/LoginOne';
import LoginSweetalert from '../Components/Pages/Auth/LoginSweetalert';
import LoginTooltip from '../Components/Pages/Auth/LoginTooltip';
import LoginTwo from '../Components/Pages/Auth/LoginTwo';
import LoginValidation from '../Components/Pages/Auth/LoginValidation';
import Maintenance from '../Components/Pages/Auth/Maintenance';
import RegisterBgImg from '../Components/Pages/Auth/RegisterBgImg';
import RegisterSimple from '../Components/Pages/Auth/RegisterSimple';
import RegisterVideo from '../Components/Pages/Auth/RegisterVideo';
import UnlockUser from '../Components/Pages/Auth/UnlockUser';
import ErrorPage1 from '../Components/Pages/ErrorPages/ErrorPage400';
import ErrorPage2 from '../Components/Pages/ErrorPages/ErrorPage401';
import ErrorPage3 from '../Components/Pages/ErrorPages/ErrorPage403';
import ErrorPage4 from '../Components/Pages/ErrorPages/ErrorPage404';
import Logins from '../Auth/Signin';
import LoginForm from '../Components/Pages/Auth/LoginForm';
import ComingBgImg from '../Components/Pages/ComingSoon/ComingBgImg';
import ComingBgVideo from '../Components/Pages/ComingSoon/ComingBgVideo';
import Error500 from '../Components/Pages/ErrorPages/ErrorPage500';
import Error503 from '../Components/Pages/ErrorPages/ErrorPage503';
import EmailVerif from '../Components/Pages/Auth/EmailVerif';

// import PublicLink from "../Components/Application/SmartLink/Common/FileDisplayPage";
// import GeniusLayout from "../Components/Application/GeniuesLink/GeniusLayout";

import PinModalContent from '../Auth/OtherWays/PinModalContent';

export const authRoutes = [
  { path: appPath('/login'), Component: Logins },
  {path: appPath('/login/otp-verif/:param'), Component: PinModalContent},
  { path: appPath('/pages/authentication/login-simple/:layout'), Component: LoginForm },
  { path: appPath('/pages/authentication/login-img/:layout'), Component: LoginOne },
  { path: appPath('/pages/authentication/login-bg-img/:layout'), Component: LoginTwo },
  { path: appPath('/pages/authentication/login-validation/:layout'), Component: LoginValidation },
  { path: appPath('/pages/authentication/login-tooltip/:layout'), Component: LoginTooltip },
  { path: appPath('/pages/authentication/login-sweetalert/:layout'), Component: LoginSweetalert },
  { path: appPath('/pages/authentication/register-simple/:layout'), Component: RegisterSimple },
  { path: appPath('/pages/authentication/register-bg-img/:layout'), Component: RegisterBgImg },
  { path: appPath('/pages/authentication/register-video/:layout'), Component: RegisterVideo },
  { path: appPath('/pages/authentication/unlock-user/:layout'), Component: UnlockUser },
  

  { path: appPath('/pages/authentication/create-pwd/:layout'), Component: CreatePwd },
  { path: appPath('/pages/authentication/maintenance/:layout'), Component: Maintenance },
  { path: appPath('/verify-email/:token'), Component: EmailVerif },

  //ForgotPassword
  { path: appPath('/forget-pwd'), Component: ForgetPwd },
  // { path: appPath('/verify-otp'), Component: OtpVerif },
  { path: appPath('/reset-pwd'), Component: ResetPwd },
  //Coming-soon
  { path: appPath('/pages/comingsoon/comingsoon/:layout'), Component: ComingSimple },
  { path: appPath('/pages/comingsoon/coming-bg-img/:layout'), Component: ComingBgImg },
  { path: appPath('/pages/comingsoon/coming-bg-video/:layout'), Component: ComingBgVideo },
  // { path: appPath('/smart/:param/'), Component: PublicLink },
  // { path: appPath('/smartLink/:productName'), Component: GeniusLayout },

  //Error
  { path: appPath('/pages/errors/error400/:layout'), Component: ErrorPage1 },
  { path: appPath('/pages/errors/error401/:layout'), Component: ErrorPage2 },
  { path: appPath('/pages/errors/error403/:layout'), Component: ErrorPage3 },
  { path: appPath('/pages/errors/error404/:layout'), Component: ErrorPage4 },
  { path: appPath('/pages/errors/error500/:layout'), Component: Error500 },
  { path: appPath('/pages/errors/error503/:layout'), Component: Error503 },
];
